import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import AppSideScroll from './AppSideScroll';
import { colors, spacing } from '../../lib/theme';
import Podcast from '../Podcast/Podcast';
import AppAlertDiv from './AppAlertDiv';
import VideoThumbnail from './VideoThumbnail';
import { bookVideoFromRawId, bookVideoThumbFromRaw } from '../../lib/utils';
import AppCustomLink from './AppCustomLink';

class TrendingVideos extends Component {
    render() {
        const { topPodcasts, userDetails } = this.props;
        console.dir(topPodcasts);
        const topPodcastsVideos = topPodcasts['video-0'] || [];
        if (userDetails && userDetails.uid) {
            if (!topPodcastsVideos || topPodcastsVideos.length < 1) {
                return (<></>)
            }
        }
        return (
            <div style={{ marginBottom: '64px' }}>
                <AppSideScroll title={'Short Video Summaries'}>
                    {
                        // (!userDetails || !userDetails.uid) ? <div style={{ width: '100vw', marginBottom: '48px' }}>
                        //     <AppAlertDiv message={`Your book recommendations will show up here.`} showIcon />

                        // </div> : 
                        (topPodcastsVideos).map((podcast, index) =>
                            <div key={index} style={{ marginRight: `${spacing('lg')}` }}>
                                <div>
                                    <VideoThumbnail
                                        userDetails={userDetails}
                                        videoUrl={bookVideoFromRawId(podcast['videoUrl'])}
                                        thumbnailUrl={bookVideoThumbFromRaw(podcast['videoThumb'])} />
                                    <p className='text-center artist'>{podcast.artistName}</p>
                                    <h4 className='text-center' style={{ color: colors.primary }}>
                                        <AppCustomLink href={`/book?id=${podcast.collectionId}`}>
                                            Full Summary
                                        </AppCustomLink>
                                    </h4>
                                </div>
                            </div>
                        )
                    }
                </AppSideScroll>
                <style jsx>
                    {`
                    p {
                    margin-top: 8px;
                    margin-bottom: 4px;
                    }
                    h4 {
                        color: ${colors.primary} !important;
                        font-weight: 500;
                    }
                        .artist {
                            white-space: nowrap;
                            overflow: overlay;
                            overflow: hidden;
                            /* display: block; */
                            text-overflow: ellipsis;
                            max-width: 200px;
                        }
                    `}
                </style>
            </div>
        )
    }
}

TrendingVideos.propTypes = {
    forYouEpisodes: PropTypes.object,
    topPodcasts: PropTypes.array,
    userDetails: PropTypes.object,
    // showMore: PropTypes.bool,
    getBrowsePodcasts: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        // forYouEpisodes: state.forYouEpisodes,
        // dbPodcastState: state.dbPodcastState,
        userDetails: state.userDetails,
        topPodcasts: state.topPodcasts,
        // userPlaylists: state.userPlaylists,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // getBrowsePodcasts: bindActionCreators(getBrowsePodcasts, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TrendingVideos);
